export default __webpack_public_path__ + "static/media/tn.090d27f2.jpg";